/**
 * gift-wrapping-cart.js — Eurus theme
 * -----------------------------------------------------------------
 * Permite marcar / desmarcar "¿Lo necesitas para regalo?" desde el
 * cart drawer y la página de carro.
 *
 * Hace LAS DOS COSAS que hace la ficha de producto:
 *   1. Pone / quita la line item property en la línea del producto.
 *   2. Agrega / quita el producto de bolsa de regalo del carro.
 * -----------------------------------------------------------------
 */
(function () {
  'use strict';

  // Debe coincidir EXACTAMENTE con el nombre en snippets/gift-wrapping-cart.liquid
  var PROP_NAME = '¿Lo necesitas para regalo?'; // ¿Lo necesitas para regalo?
  var PROP_VALUE = 'Sí'; // Sí

  /* =================================================================
     REGLA DE CANTIDAD DE LA BOLSA — ajusta esto si no calza
     -----------------------------------------------------------------
     'one_per_order' → 1 bolsa, sin importar cuántos productos se
                       marquen como regalo.
     'per_item'      → 1 bolsa por cada línea marcada como regalo
                       (2 productos marcados = 2 bolsas).
     'per_unit'      → 1 bolsa por cada unidad marcada
                       (1 producto con cantidad 3 = 3 bolsas).

     Para saber cuál usar: marca la casilla en una ficha de producto,
     agrega al carro y mira qué cantidad de bolsa aparece. Luego marca
     un segundo producto distinto y mira si sube a 2 o se queda en 1.
     ================================================================= */
  var WRAP_MODE = 'one_per_order';

  var REOPEN_FLAG = 'x-gift-reopen-drawer';

  /* --------------------------- estilos --------------------------- */
  function injectStyles() {
    if (document.getElementById('x-gift-wrapping-cart-styles')) return;
    var style = document.createElement('style');
    style.id = 'x-gift-wrapping-cart-styles';
    style.textContent = [
      '.x-gift-wrapping-cart{margin-top:10px;margin-bottom:2px;transition:opacity .2s ease}',
      '.x-gift-wrapping-cart.is-busy{opacity:.5;pointer-events:none}',
      '.x-gift-wrapping-cart__spinner{display:none;width:14px;height:14px;margin-inline-start:8px;',
      'border:2px solid currentColor;border-top-color:transparent;border-radius:50%;opacity:.6;',
      'animation:x-gift-spin .6s linear infinite}',
      '.x-gift-wrapping-cart.is-busy .x-gift-wrapping-cart__spinner{display:inline-block}',
      '@keyframes x-gift-spin{to{transform:rotate(360deg)}}'
    ].join('');
    (document.head || document.documentElement).appendChild(style);
  }

  /* --------------------------- helpers --------------------------- */
  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function setBusy(input, busy) {
    input.disabled = busy;
    var wrapper = input.closest('.x-gift-wrapping-cart');
    if (wrapper) wrapper.classList.toggle('is-busy', busy);
  }

  function wrapVariantId(input) {
    var wrapper = input.closest('.x-gift-wrapping-cart');
    var raw = wrapper && wrapper.getAttribute('data-gift-wrap-variant');
    var id = parseInt(raw, 10);
    return isNaN(id) ? null : id;
  }

  function getJSON(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (body) {
        if (!res.ok) throw new Error((body && body.description) || res.statusText);
        return body;
      });
    });
  }

  function fetchCart() {
    return getJSON(root() + 'cart.js', { headers: { Accept: 'application/json' } });
  }

  function postJSON(path, payload) {
    return getJSON(root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  /* ------------------- cálculo de la bolsa ----------------------- */
  function giftLines(cart, wrapId) {
    return cart.items.filter(function (i) {
      if (wrapId && i.variant_id === wrapId) return false;
      return !!(i.properties && i.properties[PROP_NAME]);
    });
  }

  function desiredWrapQty(cart, wrapId) {
    var lines = giftLines(cart, wrapId);
    if (lines.length === 0) return 0;
    if (WRAP_MODE === 'one_per_order') return 1;
    if (WRAP_MODE === 'per_unit') {
      return lines.reduce(function (sum, i) { return sum + i.quantity; }, 0);
    }
    return lines.length; // per_item
  }

  // Ajusta la línea de bolsa de regalo para que calce con la regla.
  // Devuelve true si el carro cambió (hay que refrescar la vista).
  function reconcileWrap(wrapId) {
    if (!wrapId) return Promise.resolve(false);

    return fetchCart().then(function (cart) {
      var wanted = desiredWrapQty(cart, wrapId);
      var existing = cart.items.filter(function (i) { return i.variant_id === wrapId; })[0];
      var current = existing ? existing.quantity : 0;

      if (wanted === current) return false;

      if (existing) {
        return postJSON('cart/change.js', { id: existing.key, quantity: wanted })
          .then(function () { return true; });
      }
      return postJSON('cart/add.js', { items: [{ id: wrapId, quantity: wanted }] })
        .then(function () { return true; });
    });
  }

  /* ------------------- reabrir el drawer ------------------------- */
  function rememberDrawer() {
    try {
      var drawer = document.getElementById('CartDrawer');
      if (drawer && drawer.classList.contains('cart-open')) {
        sessionStorage.setItem(REOPEN_FLAG, '1');
      }
    } catch (e) { /* sessionStorage bloqueado */ }
  }

  function reopenDrawerIfNeeded() {
    var flag;
    try {
      flag = sessionStorage.getItem(REOPEN_FLAG);
      if (flag) sessionStorage.removeItem(REOPEN_FLAG);
    } catch (e) { return; }
    if (!flag) return;

    var tries = 0;
    var timer = setInterval(function () {
      tries++;
      try {
        var store = window.Alpine && window.Alpine.store && window.Alpine.store('xMiniCart');
        if (store) {
          if (typeof store.showCart === 'function') store.showCart();
          else store.open = true;
          clearInterval(timer);
          return;
        }
      } catch (e) { /* ignorar */ }
      if (tries > 20) clearInterval(timer);
    }, 150);
  }

  /* --------------------------- toggle ---------------------------- */
  function toggle(input) {
    var key = input.getAttribute('data-gift-key');
    var wanted = input.checked;
    var wrapId = wrapVariantId(input);
    if (!key) return;

    setBusy(input, true);

    fetchCart()
      .then(function (cart) {
        var line = cart.items.filter(function (i) { return i.key === key; })[0];
        if (!line) {
          window.location.reload();
          return Promise.reject('line-not-found');
        }

        var properties = {};
        Object.keys(line.properties || {}).forEach(function (k) {
          properties[k] = line.properties[k];
        });
        // String vacío = Shopify elimina la propiedad
        properties[PROP_NAME] = wanted ? PROP_VALUE : '';

        var payload = { id: key, quantity: line.quantity, properties: properties };
        if (line.selling_plan_allocation && line.selling_plan_allocation.selling_plan) {
          payload.selling_plan = line.selling_plan_allocation.selling_plan.id;
        }

        return postJSON('cart/change.js', payload);
      })
      .then(function () {
        return reconcileWrap(wrapId);
      })
      .then(function () {
        // La bolsa cambia el total del carro, así que hay que
        // re-renderizar. Recargamos y reabrimos el drawer si estaba abierto.
        rememberDrawer();
        window.location.reload();
      })
      .catch(function (error) {
        if (error === 'line-not-found') return;
        input.checked = !wanted;
        setBusy(input, false);
        console.error('[gift-wrapping-cart]', error);
      });
  }

  window.eurusGiftWrap = {
    toggle: toggle,
    reconcileWrap: reconcileWrap,
    PROP_NAME: PROP_NAME,
    PROP_VALUE: PROP_VALUE,
    WRAP_MODE: WRAP_MODE
  };

  /* --------------------------- init ------------------------------ */
  function init() {
    injectStyles();
    reopenDrawerIfNeeded();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Respaldo: si Alpine reinyecta el nodo sin el atributo onchange.
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (
      target &&
      target.matches &&
      target.matches('[data-gift-key]') &&
      !target.getAttribute('onchange')
    ) {
      toggle(target);
    }
  });
})();